import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const ThumbsDown = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M17.2521 12.75H20.25C20.8023 12.75 21.25 12.3023 21.25 11.75V4.25003C21.25 3.69775 20.8023 3.25003 20.25 3.25003H17.2521M17.2521 3.25003V12.5L13.2835 20.2078C13.112 20.5408 12.7635 20.75 12.389 20.75C11.1622 20.75 10.2249 19.6547 10.4139 18.4419L10.9892 14.75H5.74908C3.91335 14.75 2.50859 13.1145 2.78476 11.2987L3.62128 5.7987C3.84421 4.33301 5.1038 3.25003 6.5856 3.25003H17.2521Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M18.0022 4.00003V12H20.2502C20.3882 12 20.5002 11.8881 20.5002 11.75V4.25003C20.5002 4.11196 20.3882 4.00003 20.2502 4.00003H18.0022ZM17.5809 13.5H20.2502C21.2167 13.5 22.0002 12.7165 22.0002 11.75V4.25003C22.0002 3.28353 21.2167 2.50003 20.2502 2.50003H6.58575C4.733 2.50003 3.15858 3.85406 2.87996 5.68593L2.04344 11.1859C1.69829 13.4552 3.45391 15.5 5.74923 15.5H10.1134L9.67296 18.3264C9.41317 19.9935 10.7016 21.5 12.3891 21.5C13.0399 21.5 13.6483 21.1379 13.9504 20.5511L17.5809 13.5Z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
